import React, { useState } from 'react';
import { useMutation } from '@apollo/client';
import gql from 'graphql-tag';

const UPLOAD_TFS_LIST = gql`
  mutation UploadTfsList($file: Upload!) {
    uploadTfsList(file: $file)
  }
`;

const UploadTfsList = () => {
  const [file, setFile] = useState(null);
  const [uploadTfsList, { loading, error }] = useMutation(UPLOAD_TFS_LIST);
  const [message, setMessage] = useState('');
  const [uploading, setUploading] = useState(false);

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    setFile(selectedFile);
    setMessage('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!file) {
      setMessage('Please select a file to upload.');
      return;
    }

    // Validate file type
    if (!file.name.toLowerCase().endsWith('.xlsx')) {
      setMessage('Please select an Excel (.xlsx) file.');
      return;
    }

    setUploading(true);
    
    try {
      const { data } = await uploadTfsList({ 
        variables: { file },
        context: {
          // This ensures the file is properly serialized for upload
          hasUpload: true
        }
      });
      
      if (data && data.uploadTfsList) {
        setMessage('TFS list updated successfully!');
        setFile(null);
        document.getElementById('file-input').value = ''; // Clear file input
      } else {
        setMessage('File upload failed. Please try again.');
      }
    } catch (err) {
      console.error('Upload error:', err);
      setMessage(`Error uploading file: ${err.message}`);
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="bg-white p-6 rounded-lg shadow-lg max-w-md mx-auto mt-6">
      <h2 className="text-2xl font-semibold text-gray-800 mb-4">Upload New TFS List</h2>
      <p className="text-gray-600 mb-4">Upload a new TfsList.xlsx file to replace the existing one. This action is only available to superusers.</p>
      
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block text-gray-700 font-medium mb-1">Select Excel File (.xlsx):</label>
          <input
            id="file-input"
            type="file"
            accept=".xlsx"
            onChange={handleFileChange}
            className="w-full p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>
        <button
          type="submit"
          disabled={loading || uploading}
          className="w-full bg-blue-600 text-white p-2 rounded-md hover:bg-blue-700 disabled:bg-gray-400"
        >
          {loading || uploading ? 'Uploading...' : 'Upload TFS List'}
        </button>
      </form>
      
      {message && (
        <p className={`mt-4 text-center ${message.includes('Error') ? 'text-red-500' : 'text-green-500'}`}>
          {message}
        </p>
      )}
      
      {error && <p className="text-red-500 mt-4 text-center">Error: {error.message}</p>}
      
      {file && (
        <div className="mt-4">
          <p className="text-gray-700">Selected file: <span className="font-semibold">{file.name}</span></p>
          {file.size && (
            <p className="text-gray-700">Size: <span className="font-semibold">{(file.size / 1024).toFixed(2)} KB</span></p>
          )}
        </div>
      )}
    </div>
  );
};

export default UploadTfsList;